// Utilities for handling quantities with implied two decimal places
// Frontend displays with comma separator and two decimals (e.g., 10,20)
// Backend expects scaled integers in hundredths (e.g., 1020)

const hasDecimalSeparator = (valueStr) => /[.,]/.test(valueStr);

export const toScaledInteger = (raw) => {
  if (raw === null || raw === undefined) return 0;
  const str = String(raw).trim();
  if (str === '') return 0;
  if (hasDecimalSeparator(str)) {
    const normalized = str.replace(',', '.');
    const num = Number(normalized);
    if (Number.isNaN(num)) return 0;
    return Math.round(num * 100);
  }
  const isNegative = str.startsWith('-');
  const digitsOnly = str.replace(/[^0-9]/g, '');
  const intVal = Number.parseInt(digitsOnly, 10);
  if (Number.isNaN(intVal)) return 0;
  return isNegative ? -intVal : intVal;
};

export const toScaledIntegerStringFromParts = (whole, decimal) => {
  const wholeInt = Number.parseInt(String(whole || '0'), 10);
  const decimalStr = String(decimal || '').padEnd(2, '0').slice(0, 2);
  const decimalInt = Number.parseInt(decimalStr, 10) || 0;
  const scaled = (Number.isNaN(wholeInt) ? 0 : wholeInt) * 100 + decimalInt;
  return String(scaled);
};

export const splitFromRaw = (raw) => {
  if (raw === null || raw === undefined) {
    return { whole: '', decimal: '' };
  }
  const str = String(raw).trim();
  if (!str) return { whole: '', decimal: '' };

  const scaled = toScaledInteger(str);
  const whole = Math.floor(scaled / 100);
  const decimal = String(scaled % 100).padStart(2, '0');
  return { whole: String(whole), decimal };
};

export const formatScaledAmount = (raw) => {
  if (raw === null || raw === undefined || String(raw).trim() === '') return '';
  const scaled = toScaledInteger(raw);
  const sign = scaled < 0 ? '-' : '';
  const abs = Math.abs(scaled);
  const whole = Math.floor(abs / 100);
  const decimal = String(abs % 100).padStart(2, '0');
  return `${sign}${whole},${decimal}`;
};

export default {
  toScaledInteger,
  toScaledIntegerStringFromParts,
  splitFromRaw,
  formatScaledAmount,
};


